import ControlGroupDetail from "../js/components/controlGroup/ControlGroupDetail.react";
export default ControlGroupDetail;
